import { Dropdown } from 'antd'
import {
    LogoutOutlined
} from '@ant-design/icons';

import logo from '../../../../../assets/logo.png'

const RenderHeader = props => {
    const userInfo = JSON.parse(localStorage.getItem('USER_INFO') || '{}')

    const handleOnLogout = () => {
        localStorage.clear()
        window.location.href = '/9165/login'
    }

    const items = [
        {
            key: 'exit',
            label: <div onClick={handleOnLogout}>
                <LogoutOutlined style={{ marginRight: '4px' }} />
                退出登录
            </div>,
        },
    ]

    return <div className='header-wrapper '>
        <div className="title">
            <img src={logo} alt='' />
            <span>九尾陆吾后台管理系统</span>
        </div>
        <Dropdown menu={{ items }}>
            <div className="user">
                欢迎您，尊敬的管理员&nbsp;
                <span>{userInfo.nickName || userInfo.id}</span>
            </div>
        </Dropdown>
    </div>
}

export default RenderHeader
